/**
 * 定高虚拟列表的区间计算（纯函数；DOM 接线在 FixedList.tsx）。
 *
 * 与 virtualizer.ts（聊天时间线）**刻意分开，不复用**：那套的单一 anchor 语义是
 * 「锚住某行」——prepend/测高/重排后保持 anchor 行的视口位置。会话列表要的恰恰
 * 相反：贴顶时重排序（新消息把某会话顶到第 1 位）必须留在顶部看到新顺序，锚行
 * 语义会把视口跟着旧首行往下推、挡住新置顶的会话。会话行定高（行组件 CSS 保证），
 * 无需测高/补偿，一个 scrollTop 就是全部滚动状态；内容总高不变的重排序下浏览器
 * 天然保持 scrollTop。
 */

export interface FixedRange {
  /** 渲染区间 [start, end) */
  readonly start: number;
  readonly end: number;
  readonly totalHeight: number;
}

export function fixedRange(
  scrollTop: number,
  viewportHeight: number,
  itemHeight: number,
  count: number,
  overscanPx: number,
): FixedRange {
  const totalHeight = count * itemHeight;
  if (count === 0 || itemHeight <= 0) return { start: 0, end: 0, totalHeight };
  // 夹进有效滚动范围（iOS 橡皮筋越界值）
  const top = Math.min(Math.max(scrollTop, 0), Math.max(totalHeight - viewportHeight, 0));
  const start = Math.max(0, Math.floor((top - overscanPx) / itemHeight));
  const end = Math.min(count, Math.ceil((top + viewportHeight + overscanPx) / itemHeight));
  return { start, end: Math.max(end, start), totalHeight };
}
